/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { hideModal } from '../../actions/actions';
import FlagModal from './flag.modal';

export const mapStateToProps = (state, ownProps) => {
  return {
    content: ownProps.props.content
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hide: () => {
      dispatch(hideModal());
    }
  };
};

const FlagContainer = connect(mapStateToProps, mapDispatchToProps)(FlagModal);

export default FlagContainer;
